module.exports = __webpack_public_path__ + "static/image2-a519414af293892d847ff5ae36b91daa.jpg";